import React, { useState } from 'react'
import MajorEvents from "./MajorEvents/MajorEvents"
import PastSurgeries from "./PastSurgeries/PastSurgeries"
import PreventiveCare from "./PreventiveCare/PreventiveCare"
import NutritionHistory from "./NutritionHistory/NutritionHistory"
import DevelopmentHistory from "./DevelopmentHistory/DevelopmentHistory"

const PastMedicalHistory = ({expandAll, data, setIsRecordSaved, patientID, ...props}) => {
  const [expandItems, setExpandItems] = useState(true);
  console.log("PastMedicalHistory", patientID)
  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }
  return (
    <div className='content-box px-0'>
        <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1 mx-2'>
            <p className='cursor-pointer fs-13 heading user-select-none'  onClick={handleToggleExpand}>Past Medical History</p>
        </div>
        {expandItems &&
        expandAll &&
        <div>
            <MajorEvents data={data?.MajorEvents || []}  setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={props?.isViewAllowed} IsEditAllowed={props?.IsEditAllowed} IsDeleteAllowed={props?.IsDeleteAllowed}/>
            <PastSurgeries data={data?.PastSurgeries || []}  setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={props?.isViewAllowed} IsEditAllowed={props?.IsEditAllowed} IsDeleteAllowed={props?.IsDeleteAllowed}/>
            <PreventiveCare data={data?.PreventiveCare || []}  setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={props?.isViewAllowed} IsEditAllowed={props?.IsEditAllowed} IsDeleteAllowed={props?.IsDeleteAllowed}/>
            <NutritionHistory data={data?.NutritionHistory || []}  setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={props?.isViewAllowed} IsEditAllowed={props?.IsEditAllowed} IsDeleteAllowed={props?.IsDeleteAllowed}/>
            <DevelopmentHistory data={data?.DevelopmentHistory || []}  setIsRecordSaved={setIsRecordSaved} patientID={patientID} isViewAllowed={props?.isViewAllowed} IsEditAllowed={props?.IsEditAllowed} IsDeleteAllowed={props?.IsDeleteAllowed}/>
            {/* <div>
                <p className='heading pb-2'>Allergies</p>
                <div className='d-flex align-items-center justify-content-between mb-2'>
                    <p className='text validate-color'>Cucumber Melon</p>
                    <p className='text orange-clr'>Mild</p>
                </div>
            </div> */}
        </div>}
    </div>
  )
}

export default PastMedicalHistory